import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const deleteinvoice = (state) => {

  return axios.delete(API + "billing/invoice-delete/"+state+"/",{headers: authHeader(),});
};

const DeleteInvoiceService = {
    deleteinvoice,
  };
  export default DeleteInvoiceService;